module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/1-ls-18b79609440200d7f3431063b9d009ec.jpg";